import { filePlayer } from '@/components/file/utils'

import render from './render'

export default {
  name: 'FileItemPlayer',

  mixins: [ filePlayer ],

  render
}
